//import './index.css';

import App from './components/app/App';
import { RESOURCES_ACCESS } from '../../global/app-global-values';
import React from 'react';

const TranslationResources = () => <App />;

export default {
  routeProps: {
    path: '/translation-resources',
    component: TranslationResources,
  },
  name: 'TranslationResources',
  label: 'Translation Resources',
  iconClassName: 'icon-wrench',
  active: true,
  accessGroup: RESOURCES_ACCESS,
};
